// extracted by mini-css-extract-plugin
export default {"group":"doI7JGBBUR","groupTitle":"JbJkllUToX","iconList":"EsQGPwXrT5"};